import React from 'react';
import ReactSVG from 'react-svg';
import { connect } from 'react-redux';
import { withRouter, NavLink, Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import Logo from './Logo';
import Avatar from './Avatar';
import Button from './Button';
import Search from './Search';
import email from '../img/email.svg';

class Header extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;

    this.nav = [
      { route: '/projects', name: t('nav.projects') },
      { route: '/users', name: t('nav.users') },
      { route: '/newsletters', name: t('nav.newsletters') },
    ];

    const { user, workspace, isDueDatePassed } = this.props;
    const isAdmin =
      user && workspace.admins && workspace.admins.includes(user._id);
    if (isAdmin) {
      this.nav.push({
        route: '/admin/invites',
        name: `${isDueDatePassed ? '❗' : ''} ${t('nav.admin')}`,
      });
    }

    const { daysToNextUpdate } = this.props;
    this.flagModifierClass = this.getModifierClass(
      'c-header__flag',
      daysToNextUpdate
    );
    this.headerModifierClass = this.getModifierClass(
      'c-header',
      daysToNextUpdate
    );

    this.state = {
      isMobileMenuOpen: false,
      isSearchOpen: false,
    };
  }

  componentDidMount() {
    // On route change, close search
    // Use case: when a search is made and the user clicks on results
    this.props.history.listen((location, action) => {
      this.handleMobileMenuClose();
    });
  }

  getModifierClass(baseClass, daysToNextUpdate) {
    // in case something strange happens... display the default one
    if (daysToNextUpdate < 0) {
      return `${baseClass}--default`;
    }

    if (daysToNextUpdate > 7) {
      return `${baseClass}--default`;
    } else if (daysToNextUpdate > 3) {
      return `${baseClass}--warning`;
    } else {
      return `${baseClass}--danger`;
    }
  }

  handleMobileMenuClose = () => this.setState({ isMobileMenuOpen: false });

  renderNav = (links) => {
    return links.map((link, i) => (
      <li key={i} className="o-list-inline__item">
        <NavLink
          onClick={this.handleMobileMenuClose}
          className="c-header__nav__item c-btn--effect"
          activeClassName="active"
          to={`${link.route}`}
        >
          {link.name}
        </NavLink>
      </li>
    ));
  };

  renderAvatar = (user) => (
    <Link to="/my-profile">
      <Avatar src={user.getSmallAvatarUrl()} />
    </Link>
  );

  handleSearchOpen = () => {
    const { isSearchOpen } = this.state;

    this.setState({ isSearchOpen: !isSearchOpen }, () => {
      document.querySelector('.react-autosuggest__input').focus();
    });
  };

  handleSearchEscape = () => {
    this.setState({ isSearchOpen: false });
  };

  toggleMobileMenuOpen = () =>
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });

  render() {
    const {
      user,
      daysToNextUpdate,
      nextUpdate,
      t,
      shouldPromptConfirm,
    } = this.props;
    const { isMobileMenuOpen, isSearchOpen } = this.state;

    return (
      <header className={`c-header ${this.headerModifierClass}`}>
        <div className="c-header__wrapper o-wrapper o-wrapper--large">
          <Link to="/home">
            <Logo width="60" height="41" />
          </Link>
          <Button
            onClick={this.toggleMobileMenuOpen}
            className="nav-toggler c-header__nav__item"
            type="button"
          >
            {t('nav.menu')}
          </Button>
          <ul className="o-list-inline u-margin-bottom-none c-header__nav">
            {this.renderNav(this.nav)}
          </ul>

          <span className="c-header__spacer" />

          {isSearchOpen && <Search onEscape={this.handleSearchEscape} />}

          <div className="c-header__submenu-wrapper">
            {this.renderAvatar(user)}
            {isSearchOpen ? (
              <Button
                onClick={this.handleSearchOpen}
                styleType="close"
                className="u-margin-left-small"
              />
            ) : (
              <Button
                onClick={this.handleSearchOpen}
                styleType="search"
                className="u-margin-left-small"
              />
            )}
          </div>

          <div className={`c-header__flag ${this.flagModifierClass}`}>
            <span className="c-header__flag-content">
              {t('newsletter.comingIn', { comingIn: nextUpdate })}
              <br />
              {shouldPromptConfirm ? (
                <Link className="c-header__flag-link" to="/updates/confirm">
                  {t('newsletter.confirmYourInfo')}
                </Link>
              ) : (
                <Link className="c-header__flag-link" to="/updates/last">
                  {t('newsletter.manageYourUpdates')}
                </Link>
              )}
            </span>
            <Link
              to="/updates/last"
              className="c-header__flag-icon u-text-center"
            >
              <ReactSVG src={email} />

              <span className="c-header__flag-message">
                {t('newsletter.remaining', {
                  postProcess: 'interval',
                  count: daysToNextUpdate,
                })}
              </span>
            </Link>
          </div>
        </div>
        <div
          className={`c-header__nav-mobile ${isMobileMenuOpen ? 'active' : ''}`}
        >
          <div className="c-header__search-small u-display-flex u-align-items-center u-justify-content-between u-margin-horizontal-large u-margin-top-small u-margin-bottom-tiny">
            {this.renderAvatar(user)}
            <Search onEscape={this.handleSearchEscape} />
          </div>
          <ul className="o-list-inline u-margin-bottom-none">
            {this.renderNav(this.nav)}
          </ul>
        </div>
      </header>
    );
  }
}

const mapStateToProps = ({ user, workspace }) => ({
  user: user.data,
  workspace: workspace.data,
  isDueDatePassed:
    workspace.data &&
    workspace.data.status &&
    workspace.data.status.isDueDatePassed,
});

export default withRouter(connect(mapStateToProps)(translate()(Header)));



// WEBPACK FOOTER //
// ./src/common/Header.js